module.exports = __webpack_public_path__ + "img/page-10.8b4306fd.jpg";